/**
 * A fingerprint of a script's actions, used to decide whether the Handy already has this exact script
 * (prewarmed or uploaded) or needs a fresh upload.
 *
 * It used to be the point COUNT plus the first, middle and last point only, so editing any other point
 * gave the same fingerprint and the Handy kept playing the previous version of the script. This hashes
 * every point's time and position (FNV-1a, 32-bit), so any edit changes it.
 */
export function hashActions(actions: ReadonlyArray<{ at: number; pos: number }>): string {
  const n = actions.length
  if (n === 0) return "0"
  let h = 0x811c9dc5
  for (let i = 0; i < n; i++) {
    const a = actions[i]
    // Whole-millisecond time and 0.01 position are far finer than anything the device resolves.
    h = Math.imul(h ^ (Math.round(a.at) | 0), 0x01000193)
    h = Math.imul(h ^ (Math.round(a.pos * 100) | 0), 0x01000193)
  }
  return `${n}_${(h >>> 0).toString(16)}`
}
